// Component disabled on purpose
// Allas doesn't use AffiliateGallery now, it's styled just in case, if something changed

import { StandaloneAffiliateGallery } from 'base/components/AffiliateGallery';

export const AllasStandaloneAffiliateGallery: typeof StandaloneAffiliateGallery = () => null;
